<template>
  <div>
    <el-form :model="form" label-width="80px">
      <el-form-item label="栏目名称">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input v-model="form.intro"></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <el-form-item v-for="item in form.content" :key="item.id">
          <el-form-item label="标题" class="ab">
            <el-input v-model="item.title"></el-input>
          </el-form-item>
          <el-form-item label="简介" class="ab">
            <vue-ueditor-wrap v-model="item.intro"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item label="内容" v-if="item.content.length != 0">
            <el-form-item v-for="items in item.content" :key="items.id" class="about">
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-success="about(item.id,items.id)"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <img :src="items.img" />
              <div>
                <span>标题：</span>
                <el-input v-model="items.title"></el-input>
              </div>
              <div>
                <span>简介：</span>
                <el-input v-model="items.intro"></el-input>
              </div>
            </el-form-item>
          </el-form-item>
        </el-form-item>
      </el-form-item>
    </el-form>
    <div class="but">
      <el-button type="primary" @click="save">立即创建</el-button>
      <el-button @click="goback">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "关于我们",
        intro: "科技·创造·想象的理念，努力为树立行业旗帜而奋斗",
        content: [
          {
            id: 1,
            title: "石家庄飞天科技开发有限公司",
            intro: "",
            content: []
          },
          { id: 2, title: "飞天品牌文化", intro: "", content: [] },
          {
            id: 3,
            title: "产品流程",
            intro: "",
            content: [
              {
                id: 1,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              },
              {
                id: 2,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              },
              {
                id: 3,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              },
              {
                id: 4,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              },
              {
                id: 5,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              },
              {
                id: 6,
                img: "http://res.sjzqcrl.com/%E5%88%9B%E6%84%8Fs.jpg",
                title: "需求沟通",
                intro: "与客户进行沟通，充分了解客户的需求"
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    about() {},
    save() {},
    goback() {
      this.$router.push("/admin/index/onepage");
    }
  }
};
</script>

<style lang="less" scoped>
.about {
  width: 45% !important;
  display: inline-block;
  background: #eee;
  padding: 10px;
  margin-right: 10px;
  margin-top: 10px;
  img {
    width: 20%;
    margin: 10px 0px;
  }
  .el-input {
    display: inline-block;
    width: 80%;
  }
}
.ab {
  margin: 10px 0px;
}
.but{
  margin-left: 160px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/onepage/about.vue